/**
 * Styles partagés des tableaux de résultats de tests.
 *
 * Ces tableaux sont dupliqués sur les pages équipe (Framework, DataExploration,
 * DataPreparation, Investigation, Agentique, Osint, RobotFramework, ReadyApi).
 * Centraliser la classe évite qu'un réglage de largeur soit appliqué à un seul
 * exemplaire — c'est exactement ce qui s'était produit.
 *
 * `[&_th]:px-3 [&_td]:px-3` resserre l'espacement de toutes les cellules : à
 * `px-6`, neuf colonnes dépassaient la largeur utile et les dernières (Root Cause,
 * Actions) sortaient du champ. La barre de défilement horizontale existe, mais
 * elle reste invisible tant qu'on ne la sollicite pas, donc le contenu paraissait
 * simplement coupé.
 *
 * Les variantes arbitraires demandent Tailwind >= 3.1 ; le projet est en 3.4.
 */
export const RESULTS_TABLE_CLASS =
  'min-w-full divide-y divide-gray-200 [&_th]:px-3 [&_td]:px-3';
